import React from 'react'
import { useRouteError } from 'react-router-dom'
import { SupportButton } from '@shared/ui/support-button'
import { Button } from '@shared/ui/button/button'
import s from './error-page.module.scss'

// Детали ошибки показываем только в dev-режиме, чтобы не светить внутренности в проде
const getErrorMessage = (error) => {
	if (!error) return null
	if (typeof error === 'string') return error
	return error.message || error.statusText || null
}

export const ErrorPage = ({ error }) => {
	const details = process.env.NODE_ENV === 'development' ? getErrorMessage(error) : null

	return (
		<section className={s.wrapper}>
			<div className={s.glowTop} aria-hidden="true" />
			<div className={s.glowBottom} aria-hidden="true" />

			<div className={s.card}>
				<div className={s.badge}>Что-то пошло не так</div>

				<div className={s.visual} aria-hidden="true">
					<div className={s.vinyl}>
						<div className={s.vinylCenter}>Ой</div>
					</div>
					<div className={s.wave} />
					<span className={s.noteLeft}>♪</span>
					<span className={s.noteRight}>♫</span>
				</div>

				<div className={s.content}>
					<h1>Фальшивая нота — приложение дало сбой</h1>
					<p>Мы уже в курсе и чиним. Попробуйте обновить страницу — обычно это помогает</p>

					<div className={s.actions}>
						<Button label="Обновить страницу" onClick={() => window.location.reload()} />
						<Button label="На главную" theme="secondary" to="/" />
						<SupportButton
							label="Поддержка"
							theme="secondary"
							shape="pill"
							className={s.supportWrapper}
						/>
					</div>

					{details && <pre className={s.details}>{details}</pre>}
				</div>
			</div>
		</section>
	)
}

// Вариант для errorElement роутера: забираем ошибку через useRouteError
export const RouterErrorPage = () => {
	const error = useRouteError()

	return <ErrorPage error={error} />
}
